// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__-5s80","tooltipText":"Tooltip_tooltipText__-5+GJ"};